import React, { useState } from 'react';
import { Col, Text, Button, Input } from 'components';
import Store from 'store';

interface LoginFormProps {
  title?: string;
  description?: string;
  onLoginSuccess?: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({
  title = 'Login Required',
  description = 'Please login to access this page',
  onLoginSuccess
}) => {
  const UserStore = Store.useUserStore();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleLogin = async () => {
    setIsLoggingIn(true);
    setLoginError('');
    try {
      if (!email || !password) {
        setLoginError('Please input your email and password');
        setIsLoggingIn(false);
        return;
      }
      const res = await Store.Client.Api.User.login({
        email,
        password,
      });
      if (res.data.success && res.data.data?.token) {
        const token = res.data.data?.token;
        Store.Client.setToken(token);
        UserStore.set({
          token,
          user: res.data.data?.publicInfo,
        });
        setLoginError('');
        setIsLoggingIn(false);
        onLoginSuccess?.();
      } else {
        setLoginError(res.data.error === 'Error: Not existed' ? 'Error: User does not exist' : res.data.error);
        setIsLoggingIn(false);
      }
    } catch (err) {
      setLoginError(String(err));
      setIsLoggingIn(false);
    }
  };

  return (
    <Col flex1 p4 backgroundColor="black" middle>
      <Col backgroundColor="#222222" p4 round1 style={{ maxWidth: 400, width: '100%' }}>
        <Text h2 color="white" mb4 center>{title}</Text>
        <Text color="#888888" mb4 center>{description}</Text>

        {loginError && (
          <Text color="red" mb2>{loginError}</Text>
        )}

        <Input
          value={email}
          onChange={setEmail}
          placeholder="Input your email"
          mb2
        />
        <Input
          value={password}
          onChange={setPassword}
          placeholder="Input your password"
          password
          mb2
          inputProps={{
            onSubmitEditing: handleLogin,
          }}
        />
        <Button
          text="LOGIN"
          onPress={handleLogin}
          isLoading={isLoggingIn}
          backgroundColor="#0066cc"
          width="100%"
        />
      </Col>
    </Col>
  );
};

export default LoginForm;
